import * as React from "react";
import type { SVGProps } from "react";
const SvgEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.268 19.373A6.54 6.54 0 0 0 13 20a6.54 6.54 0 0 0 5-2.34 1.018 1.018 0 0 0-1.55-1.32A4.58 4.58 0 0 1 13 18a4.58 4.58 0 0 1-3.45-1.66A6.83 6.83 0 0 1 8.687 15H13a1 1 0 0 0 0-2H8.065a6.828 6.828 0 0 1 0-2H13a1 1 0 0 0 0-2H8.684c.217-.445.483-.868.796-1.26A4.59 4.59 0 0 1 13 6a4.58 4.58 0 0 1 3.5 1.66A1 1 0 1 0 18 6.34 6.42 6.42 0 0 0 13 4a6.56 6.56 0 0 0-5 2.46A8.899 8.899 0 0 0 6.574 9H5a1 1 0 0 0 0 2h1.102a8.9 8.9 0 0 0-.007 2H5a1 1 0 0 0 0 2h1.553c.34.96.844 1.86 1.497 2.66a6.539 6.539 0 0 0 2.218 1.713Z"
    />
  </svg>
);
export default SvgEuro;
